import { environment } from '../../environments/environment';

export const getStreamingSegmentUrl = (assetId: string, channelId: number, segment: string) =>
  `${environment.awsAPIEndpointUrl}streaming/${assetId}/${channelId}/${segment}/`;
export const streamingCaptureUrl = (assetId: string) => `streaming/${assetId}/take-photo/`;
export const streamingVideoCaptureUrl = (assetId: string, channelId: number) =>
  `streaming/${assetId}/${channelId}/request-video/`;
export const streamingTimelineUrl = (assetId: string) => `streaming/timeline/${assetId}/`;
export const streamingTimelineAvailabilityUrl = (assetId: string) =>
  `streaming/timeline/${assetId}/video-availability/`;
export const streamingCommandsUrl = 'commands/streaming/';
export const devicesConnectionStatusUrl = 'commands/streaming/connection-status/';
export const deviceConnectionStatusUrl = (connectionId: string) => `commands/streaming/connection/${connectionId}/`;
